import {ChangeDetectionStrategy, Component, computed, inject, input, output} from '@angular/core';
import * as _ from 'lodash';
import {BzIconDef} from '@bringoz/ui';
import {bzIconCloseCircle} from '@bringoz/ui/icons';
import {PanelService} from '../../../../commons/angular/services/panel.service';
import {TimekeepingFilterOption} from '../../models/timekeeping-list.model';
import {
  CustomSelectFilterPanelComponent,
  CustomSelectFilterPanelData
} from '../custom-select-filter-panel/custom-select-filter-panel.component';

/**
 * Inline multi-select filter of the toolbar, like the site filters of the scheduling project: an icon with the
 * placeholder, the selected option when there is one, or how many are selected.
 */
require('./custom-select-filter.scss');
@Component({
  standalone: false,
  selector: 'app-custom-select-filter',
  templateUrl: './custom-select-filter.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomSelectFilterComponent {

  readonly icon = input.required<BzIconDef>();
  readonly placeholder = input.required<string>();
  /** Translation key of the selected count, e.g. "{{length}} Territories". */
  readonly countLabelKey = input.required<string>();
  readonly options = input<TimekeepingFilterOption[]>([]);
  readonly selectedIds = input<string[]>([]);

  readonly selectionChange = output<string[]>();

  readonly resetIcon = bzIconCloseCircle;

  private readonly panelService = inject(PanelService);

  readonly selectedCount = computed(() => _.size(this.selectedIds()));
  /** Set only for a single selection; empty while the options are still loading, and the button then shows the count. */
  readonly selectedLabel = computed(() =>
    this.selectedCount() === 1 ? _.find(this.options(), {id: _.head(this.selectedIds())})?.label : undefined
  );
  readonly countLabelParams = computed(() => ({length: this.selectedCount()}));

  onOpenPanel(event: MouseEvent) {
    const data: CustomSelectFilterPanelData = {
      options: this.options(),
      selectedIds: this.selectedIds()
    };

    this.panelService.open(CustomSelectFilterPanelComponent, event, data, {
      position: {originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 4}
    }).afterClose$.subscribe((selectedIds: string[] | null) => {
      // A null result is Cancel or a click outside the panel - the selection stays as it is.
      if (selectedIds && !_.isEqual(_.sortBy(selectedIds), _.sortBy(this.selectedIds()))) {
        this.selectionChange.emit(selectedIds);
      }
    });
  }

  onReset(event: MouseEvent) {
    event.stopPropagation();
    this.selectionChange.emit([]);
  }
}
